import { useTranslate } from '@va/localization';
import { getAgencyCustomerInfo } from '@va/standalone/shared/selectors';
import { SelectDropdownOption } from '@va/ui/design-system';
import { getBusinessSectorOptions, getBusinessSizeOptions, getBusinessTypeOptions, isWixApp } from '@va/util/helpers';
import { getBusinessInfo } from '@va/wix/shared/selectors';
import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

export const useBusinessInfo = () => {
  const translate = useTranslate();
  const agencyCustomerInfo = useSelector(getAgencyCustomerInfo);
  const businessInfo = useSelector(getBusinessInfo);

  const businessSectorOptions: SelectDropdownOption<number>[] = useMemo(
    () => getBusinessSectorOptions(translate),
    [translate],
  );

  const getSelectedBusinessSector = useCallback(
    (businessSectorId: number | string | undefined) => {
      return businessSectorOptions.find(
        (option) =>
          Number(option.value) ===
          (typeof businessSectorId === 'string' ? Number.parseInt(businessSectorId) : businessSectorId),
      );
    },
    [businessSectorOptions],
  );

  const businessTypeOptions = useMemo(() => getBusinessTypeOptions(translate), [translate]);
  const getSelectedBusinessType = useCallback(
    (businessTypeId: number | string | undefined) => {
      return businessTypeOptions.find((option) => Number(option.value) === Number(businessTypeId));
    },
    [businessTypeOptions],
  );

  const businessSizeOptions = useMemo(() => getBusinessSizeOptions(translate), [translate]);
  const getSelectedBusinessSize = useCallback(
    (businessSizeId: number | string | undefined) => {
      return businessSizeOptions.find((option) => Number(option.value) === Number(businessSizeId));
    },
    [businessSizeOptions],
  );

  return {
    businessInfo: isWixApp() ? businessInfo : agencyCustomerInfo,
    businessSectorOptions,
    getSelectedBusinessSector,
    businessTypeOptions,
    getSelectedBusinessType,
    businessSizeOptions,
    getSelectedBusinessSize,
  };
};
